import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { TESTIDS } from "@/constants/testIds";

export default function ChangePasswordPage() {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.next !== form.confirm) return toast.error("Password baru tidak cocok.");
    if (form.next.length < 6) return toast.error("Password baru minimal 6 karakter.");
    setLoading(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Password berhasil diubah.");
      setForm({ current: "", next: "", confirm: "" });
    } catch (err) {
      toast.error(formatApiError(err?.response?.data?.detail) || "Gagal.");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid={TESTIDS.changePasswordPage} className="max-w-lg space-y-6">
      <div>
        <div className="label-tiny">Keamanan</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mt-2">Ubah Password</h1>
      </div>
      <form onSubmit={submit} className="border border-black/10 bg-white p-8 space-y-4">
        <Field label="Password Saat Ini">
          <input data-testid={TESTIDS.cpCurrent} type="password" value={form.current} onChange={(e) => setForm({ ...form, current: e.target.value })} required className="input" />
        </Field>
        <Field label="Password Baru (min. 6)">
          <input data-testid={TESTIDS.cpNew} type="password" value={form.next} onChange={(e) => setForm({ ...form, next: e.target.value })} required minLength={6} className="input" />
        </Field>
        <Field label="Konfirmasi Password Baru">
          <input data-testid={TESTIDS.cpConfirm} type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} required className="input" />
        </Field>
        <button data-testid={TESTIDS.cpSubmit} type="submit" disabled={loading}
          className="inline-flex items-center gap-2 bg-klein text-white px-6 py-3 hover:bg-black transition-colors font-semibold disabled:bg-gray-300">
          <KeyRound className="w-4 h-4" /> {loading ? "Memproses..." : "Ubah Password"}
        </button>
      </form>
      <style>{`.input { width:100%; border: 1px solid rgba(0,0,0,0.2); padding: 10px 12px; background: white; font-size: 14px; }`}</style>
    </div>
  );
}
function Field({ label, children }) { return <div><div className="label-tiny mb-2">{label}</div>{children}</div>; }
